<template>
  <!--START: Settings Form-->
  <div class="settings-form">
    <!--START: Form Content-->
    <div v-if="content.title || content.description" class="header-wrapper">
      <h3 v-if="content.title != undefined">{{ content.title }}</h3>
      <p v-if="content.description != undefined">{{ content.description }}</p>
    </div>
    <FormBuilder
      class="form-builder"
      :fields="fields"
      @fieldChanged="fieldChanged()"
    ></FormBuilder>
    <!--END: Form Content-->
  </div>
  <!--END: Settings Form-->
</template>

<script>
//Importing components
import FormBuilder from "@/components/form/FormBuilder";

export default {
  name: "SettingsForm",
  props: {
    content: Object,
    fields: Object,
  },
  data() {
    return {};
  },
  components: {
    FormBuilder,
  },
  methods: {
    fieldChanged() {
      this.$emit("fieldChanged");
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/shared/dashboard.scss";

.settings-form {
  margin: 3rem 0;
  padding-bottom: 3rem;
  border-bottom: 1px solid $greyBorderColor;
}

.form-builder ::v-deep {
  .field-item {
    &:last-child {
      margin-bottom: 0;
    }
  }
}

.alert-message {
  display: table;
  margin-top: 0.75rem;

  ::v-deep .unicon svg {
    width: 1rem;
    height: auto;
    margin-right: 0.5rem;
    margin-top: 0.15rem;
  }

  span {
    font-size: $smallerFontSize;
  }

  .alert-html {
    color: $greyColor;
  }

  .alert-notification {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 0.35rem 0.75rem;
    border-radius: 0.75rem;

    &.yellow {
      background-color: $warningYellowBackgroundColor;
      border: 1px solid $warningYellowBorderColor;

      span {
        color: $warningYellowColor;
      }

      ::v-deep .unicon svg {
        fill: $warningYellowColor;
      }
    }
  }
}

.header-wrapper {
  position: relative;
  z-index: 1;
  margin-bottom: 2.5rem;

  h3 {
    font-size: $normalFontSize;
  }

  p {
    font-size: $smallFontSize;
    opacity: $mediumOpacity;
    margin-bottom: 1rem;
  }
}
</style>
